import { render, staticRenderFns } from "./motivo.vue?vue&type=template&id=2fd61614"
import script from "./motivo.vue?vue&type=script&lang=js"
export * from "./motivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports